<template>
  <div class="member-info">
    <div v-if="fold" class="fold-info">
      <div v-for="item in canSeeMenus" :key="item.value" class="menu" @click="open(item)">
        <svg-icon :icon-class="item.icon" style="font-size: 28px"></svg-icon>
        <div class="name">{{ item.name }}</div>
      </div>
    </div>
    <div v-else class="content">
      <div class="menu-list">
        <member-menu
          ref="menuList"
          :menu-list="canSeeMenus"
          @select="selectMenu"
          :active="curTab"
          class="member-menu"
        ></member-menu>
      </div>
      <div class="detail-info">
        <template v-if="curTab === '讨论'">
          <data-discuss
            :users="users"
            :user-id-map="userIdMap"
            :all-select-options="allSelectOptions"
            ref="dataDiscuss"
            :data-id="dataId"
            :app-id="appId"
            :fold="fold"
            @blur="blur"
          ></data-discuss>
        </template>
        <template v-else-if="curTab === '团队'">
          <data-team :sheet-data="sheetData" :app-id="appId" :sheet-def="sheetDef"></data-team>
        </template>
        <template v-else-if="curTab === '日志'">
          <data-log :data-id="dataId" :app-id="appId"></data-log>
        </template>
        <template v-else-if="curTab === '审批历史'">
          <verify-history :data-id="dataId" :data-title="sheetData.title"></verify-history>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { menus } from "@/components/Sheet/DetailDialog/static"
import MemberMenu from "@/components/Sheet/SideNav/MemberMenu"
import DataLog from "@/components/Sheet/DetailDialog/DataLog"
import DataTeam from "@/components/Sheet/DetailDialog/DataTeam"
import DataDiscuss from "@/components/Sheet/DetailDialog/DataDiscuss"
import { getCompanyUsers } from "@/api/userCenter/company"
import VerifyHistory from "@/components/Sheet/DetailDialog/VerifyHistory"

export default {
  name: "member-info",
  components: { VerifyHistory, DataTeam, MemberMenu, DataLog, DataDiscuss },
  props: {
    fold: Boolean,
    dataId: String,
    appId: String,
    sheetData: Object,
    sheetDef: Object
  },
  data() {
    return {
      menus,
      curTab: "讨论",
      userList: []
    }
  },
  computed: {
    canSeeMenus() {
      return this.menus.filter(menu => !this.sheetDef.forbiddenOperations?.includes(menu.value))
    },
    users() {
      let names = this.userList.map(user => user.name)
      let duplicateNames = this.getDuplicateName(names)
      return this.userList.map(user => {
        if (duplicateNames.includes(user.name)) {
          user.nameNew = user.name + " (" + user.telephone + ")"
        } else {
          user.nameNew = user.name
        }
        return user
      })
    },
    userIdMap() {
      let result = {}
      this.users.forEach(user => (result[user.id] = user))
      return result
    },
    allSelectOptions() {
      let team = []
      if (this.sheetData.participants) {
        team = [
          {
            avatar: "",
            id: "team",
            name: "相关团队",
            nameNew: "相关团队",
            teamList: this.sheetData.participants.map(id => this.userIdMap[id])
          }
        ]
      }
      return team.concat(this.users)
    }
  },
  created() {
    this.getUsers()
  },
  watch: {
    canSeeMenus: function(newVal) {
      this.curTab = this.canSeeMenus[0].name
      this.$refs.menuList?.init()
    }
  },
  methods: {
    init() {
      this.$children.forEach(vm => vm.init && vm.init())
    },
    getUsers() {
      getCompanyUsers().then(users => {
        this.userList = users
      })
    },
    getDuplicateName(names) {
      let nameMap = {}
      names.forEach(name => {
        if (this._.keys(nameMap).includes(name)) {
          nameMap[name] = nameMap[name] + 1
        } else {
          nameMap[name] = 1
        }
      })
      let result = []
      this._.keys(nameMap).forEach(name => {
        if (nameMap[name] > 1) {
          result.push(name)
        }
      })
      return result
    },
    selectMenu(menu) {
      this.curTab = menu.name
    },
    open(menu) {
      this.$emit("changeFold")
      this.curTab = menu.name
    },
    blur() {
      this.$emit("setKeydown")
    }
  }
}
</script>
<style lang="scss" scoped>
.member-info {
  height: 100%;
  .fold-info {
    text-align: center;
    margin-top: 6px;
    .menu {
      margin-bottom: 20px;
      cursor: pointer;
      .name {
        font-size: 13px;
        color: #878a90;
      }
    }
  }
  .content {
    display: flex;
    flex-flow: column;
    overflow: hidden;
    height: 100%;
    .menu-list {
      height: 54px;
      .member-menu {
        ::v-deep {
          .el-tabs__nav-wrap::after {
            height: 1px;
          }
        }
      }
    }
    .detail-info {
      flex: 1;
      overflow: hidden;
    }
  }
}
</style>
